/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import get from 'lodash.get';
import { sectionContainSlug } from 'lib/taxonomy';

export const ECOMMERCE_DISCLAIMER_VERBIAGE = {
  // <HeaderDisclaimer> Component which is used in WaffleHeader
  legacyTodayGiftGuideText: {
    text: (
      <p>
        Our editors independently selected these items because we think you will
        enjoy them and might like them at these prices. If you purchase
        something through our links, we may earn a commission. Pricing and
        availability are accurate as of publish time.
        {' '}
        <a style={{ borderBottom: '1px solid #ff503c' }} href="https://www.today.com/shop/everything-you-need-know-about-shop-today-t161374">
          Learn more about Shop TODAY
        </a>
      </p>
    ),
  },
};

/**
 * @param {Array} subtopics
 * @returns {Boolean}
 */
export const containsDealsSubtopic = (subtopics) => {
  const dealsSubtopic = 'deals';

  const containsSubtopic = Array.isArray(subtopics)
    && !!(subtopics.find(({ slug }) => slug === dealsSubtopic));

  return containsSubtopic;
};

/**
 * @param {Array} labels
 * @returns {Boolean}
 */
export const containsShopDealsLabel = (labels) => {
  const shopDealsLabel = 'shop-deals';

  const labelsContainsShopDealsLabel = Array.isArray(labels)
    && !!(labels.find(({ slug }) => slug === shopDealsLabel));

  return labelsContainsShopDealsLabel;
};

/**
 * @param {Array} labels
 * @returns {Boolean}
 */
export const containsSponsoredCommerceLabel = (labels) => {
  const sponsoredCommerceLabel = 'sponsored-commerce';

  const containsLabel = Array.isArray(labels)
    && !!(labels.find(({ slug }) => slug === sponsoredCommerceLabel));

  return containsLabel;
};

/**
 * @param {Array} sections
 * @returns {Boolean}
 */
export const containsShoppingSection = (sections) => {
  const shoppingSectionSlug = 'shopping';

  return sectionContainSlug(sections, shoppingSectionSlug);
};

/**
 * @param {Object} source
 * @returns {Boolean}
 */
export const isSourceFromStackCommerce = (source) => {
  const organizationName = get(source, 'organization.name');

  const organizationIsStackCommerce = (organizationName === 'StackCommerce');

  return organizationIsStackCommerce;
};

/**
 * @param {String} vertical
 * @param {Object} article
 * @returns {String}
 */
export const getEcommerceArticleType = (vertical, article = {}) => {
  const { ecommerceEnabled, source, taxonomy = {} } = article;
  const { labels, subtopics, sections } = taxonomy;

  const articleContainShopDealsLabel = containsShopDealsLabel(labels);
  const articleContainsSponsoredCommerceLabel = containsSponsoredCommerceLabel(labels);

  const articleContainDealsSubtopic = containsDealsSubtopic(subtopics);

  const articleContainsShoppingSection = containsShoppingSection(sections);
  const articleDoesNotContainShoppingSection = !articleContainsShoppingSection;

  const articleSourceIsStackCommerce = isSourceFromStackCommerce(source);

  const isTodayVertical = (vertical === 'today');
  const isNotTodayVertical = !isTodayVertical;

  const isNBCNewsVertical = (vertical === 'news');

  /* eslint-disable-next-line max-len */
  const isTodayDeals = ecommerceEnabled && isTodayVertical && (articleContainShopDealsLabel || articleContainDealsSubtopic);
  if (isTodayDeals) {
    return 'todayDeals';
  }

  /* eslint-disable-next-line max-len */
  const isTodaySponsoredCommerce = ecommerceEnabled && isTodayVertical && articleContainsSponsoredCommerceLabel;
  if (isTodaySponsoredCommerce) {
    return 'todaySponsoredCommerce';
  }

  const isTodayGeneralCommerce = ecommerceEnabled && isTodayVertical;
  if (isTodayGeneralCommerce) {
    return 'todayGeneralCommerce';
  }

  /* eslint-disable-next-line max-len */
  const isNBCNewsGeneralCommerceStackCommerce = ecommerceEnabled && isNBCNewsVertical && articleSourceIsStackCommerce;
  if (isNBCNewsGeneralCommerceStackCommerce) {
    return 'nbcNewsGeneralCommerceStackCommerce';
  }

  /* eslint-disable-next-line max-len */
  const isNBCNewsGeneralCommerceShopToday = ecommerceEnabled && isNotTodayVertical && articleContainsShoppingSection;
  if (isNBCNewsGeneralCommerceShopToday) {
    return 'nbcNewsGeneralCommerceShopToday';
  }

  /* eslint-disable-next-line max-len */
  const isNBCNewsGeneralCommerce = ecommerceEnabled && isNotTodayVertical && articleDoesNotContainShoppingSection;
  if (isNBCNewsGeneralCommerce) {
    return 'nbcNewsGeneralCommerce';
  }

  return 'nbcNewsGeneric';
};

/**
 * @param {String} ecommerceArticleType
 * @param {String} kind
 * @returns {String}
 */
export const getEcommerceArticleDisclaimerVerbiage = (ecommerceArticleType, kind) => {
  const objectPath = `${ecommerceArticleType}.${kind}`;

  const ecommerceArticleDisclaimerVerbiage = get(ECOMMERCE_DISCLAIMER_VERBIAGE, objectPath);

  return ecommerceArticleDisclaimerVerbiage;
};

/**
 * @param {String} ecommerceArticleType
 * @returns {Boolean}
 */
export const shouldDisplayEcommerceDisclaimerAlternateFormat = (ecommerceArticleType) => {
  const shouldDisplayAlternateFormat = (ecommerceArticleType === 'nbcNewsGeneralCommerceStackCommerce');

  return shouldDisplayAlternateFormat;
};
